var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.35 15.191c-3.964 0-7.35.612-7.35 3.06s3.364 3.082 7.35 3.082c3.963 0 7.349-.612 7.349-3.06s-3.364-3.082-7.35-3.082M9.35 12.858c2.699 0 4.862-2.119 4.862-4.762 0-2.644-2.163-4.763-4.863-4.763-2.698 0-4.863 2.119-4.863 4.763s2.165 4.762 4.863 4.762",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.173 8.182a6.37 6.37 0 0 1-1.137 3.646c-.075.107-.009.252.122.275q.273.045.56.052c1.898.049 3.602-1.148 4.072-2.95.698-2.675-1.35-5.076-3.957-5.076q-.423 0-.818.081c-.036.008-.075.025-.095.056-.025.04-.006.09.019.123a6.4 6.4 0 0 1 1.234 3.793M21.779 15.503c-.348-.726-1.186-1.223-2.462-1.467-.602-.144-2.232-.348-3.748-.32-.023.003-.035.019-.037.028-.003.016.004.039.033.055.7.34 3.408 1.815 3.068 4.927a.207.207 0 0 0 .233.232c.667-.093 2.381-.454 2.913-1.577a2.1 2.1 0 0 0 0-1.878"
  })));
};
export default SvgUsers;